(()=>{
  if(window.__VCARE_FUTURE_2026__)return;
  window.__VCARE_FUTURE_2026__=true;
  const d=document,w=window;

  /* Load the small interaction layer once. */
  if(!d.getElementById('vcare-smooth-css')){
    const current=d.currentScript;
    if(current&&current.src){
      const href=current.src.replace(/vcare-future(?:\.min)?\.js(?:\?.*)?$/,'vcare-smooth.css');
      if(href!==current.src){
        const link=d.createElement('link');
        link.id='vcare-smooth-css';link.rel='stylesheet';link.href=href;d.head.appendChild(link);
      }
    }
  }

  /* One rAF scroll pipeline for sticky/header state. */
  let scrollRaf=0;
  const syncScroll=()=>{
    scrollRaf=0;
    const y=w.scrollY||0;
    const doc=Math.max(1,d.documentElement.scrollHeight-w.innerHeight);
    const p=y/doc;
    d.documentElement.classList.toggle('vf-scrolled',y>10);
    d.documentElement.classList.toggle('vf-scrolltop',p>.28&&p<.96);
    d.documentElement.classList.toggle('vf-sticky-buy',d.body.classList.contains('template-product')&&y>Math.min(620,w.innerHeight*.75));
  };
  const queueScroll=()=>{if(!scrollRaf)scrollRaf=w.requestAnimationFrame(syncScroll)};
  w.addEventListener('scroll',queueScroll,{passive:true});
  w.addEventListener('resize',queueScroll,{passive:true});

  const svgFor=(label)=>{
    const t=(label||'').toLowerCase();
    if(t.includes('cream'))return '<svg viewBox="0 0 24 24"><path d="M6 9h12l1 11H5L6 9Z"/><path d="M8 5h8v4H8z"/></svg>';
    if(t.includes('serum')||t.includes('facewash'))return '<svg viewBox="0 0 24 24"><path d="M12 3s5 6 5 10a5 5 0 0 1-10 0c0-4 5-10 5-10Z"/></svg>';
    if(t.includes('hair'))return '<svg viewBox="0 0 24 24"><path d="M6 20c1-8 4-13 12-16-1 8-5 13-12 16Z"/><path d="M7 18c3-3 6-5 10-7"/></svg>';
    if(t.includes('fitness')||t.includes('energy'))return '<svg viewBox="0 0 24 24"><path d="m13 2-7 11h6l-1 9 7-12h-6l1-8Z"/></svg>';
    if(t.includes('wellness')||t.includes('body'))return '<svg viewBox="0 0 24 24"><path d="M20 8c0 5-8 10-8 10S4 13 4 8a4 4 0 0 1 8-1 4 4 0 0 1 8 1Z"/></svg>';
    if(t.includes('pain'))return '<svg viewBox="0 0 24 24"><path d="M5 12h14"/><path d="m12 5-2 5h4l-2 5"/></svg>';
    if(t.includes('lip')||t.includes('beauty'))return '<svg viewBox="0 0 24 24"><path d="M4 13c4-1 5-5 8-3 3-2 4 2 8 3-4 5-12 5-16 0Z"/></svg>';
    if(t.includes('all product')||t.includes('shop'))return '<svg viewBox="0 0 24 24"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>';
    return '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="7"/><path d="M12 8v8M8 12h8"/></svg>';
  };

  const decorate=(root=d)=>{
    root.querySelectorAll('.btn,.quick-add__button,.hc-cta,.vcat__cta,.vcat__btn,.product-item,.huda-card').forEach(el=>el.classList.add('vf-spring'));
  };

  const decorateMenu=()=>{
    const menu=d.querySelector('#header-menu .drawer__menu');
    if(!menu)return;
    const lang=d.querySelector('#header-menu .drawer__bottom__row.mobile');
    if(lang&&!lang.classList.contains('vf-drawer-language')){lang.classList.add('vf-drawer-language');menu.prepend(lang)}
    menu.querySelectorAll('.sliderow__title').forEach(el=>{
      if(el.querySelector('.vf-menu-icon'))return;
      const icon=d.createElement('span');icon.className='vf-menu-icon';icon.innerHTML=svgFor(el.textContent.trim());el.prepend(icon);
    });
    if(!menu.querySelector('.vf-drawer-extras')){
      const extras=d.createElement('div');extras.className='vf-drawer-extras';
      extras.innerHTML='<p class="vf-drawer-extras__title">Your VCare shortcuts</p><div class="vf-drawer-extras__grid">'+
        '<a class="vf-drawer-extra" href="https://wa.me/923170127744"><svg viewBox="0 0 24 24"><path d="M5 19l1-3a8 8 0 1 1 3 3l-4 0Z"/><path d="M9 9c1 3 3 5 6 6"/></svg>WhatsApp</a>'+
        '<a class="vf-drawer-extra" href="https://instagram.com/vcarenatural"><svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="5"/><circle cx="12" cy="12" r="3.5"/><circle cx="17.5" cy="6.5" r=".8" fill="currentColor"/></svg>Instagram</a>'+
        '<a class="vf-drawer-extra" href="/account"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.5"/><path d="M5.5 20c.7-4 3-6 6.5-6s5.8 2 6.5 6"/></svg>My Account</a>'+
        '<a class="vf-drawer-extra" href="mailto:info@vcarenatural.com"><svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/></svg>Contact</a></div>';
      menu.append(extras);
    }
  };

  const copyBagIcon=()=>{
    const source=d.querySelector('.quick-add__button .btn__icon svg');
    d.querySelectorAll('.index-product button[name="add"][data-add-to-cart],.index-product .product__submit__add').forEach(btn=>{
      if(btn.querySelector('.vf-pdp-bag-icon'))return;
      const wrap=d.createElement('span');wrap.className='vf-pdp-bag-icon';
      wrap.innerHTML=source?source.outerHTML:'<svg viewBox="0 0 24 24"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>';
      const text=btn.querySelector('.btn__text');text?btn.insertBefore(wrap,text):btn.prepend(wrap);
    });
  };

  const stopProductAutoplay=()=>{
    d.querySelectorAll('[data-product-slideshow]').forEach(el=>{
      try{if(w.Flickity){const flkty=w.Flickity.data(el);if(flkty){flkty.options.autoPlay=false;flkty.stopPlayer&&flkty.stopPlayer()}}}catch(_){}
      el.removeAttribute('data-autoplay');
    });
  };

  const syncMenu=()=>{
    const opener=d.querySelector('.header__mobile__hamburger[data-drawer-toggle="hamburger"]');
    const menu=d.getElementById('header-menu');
    const open=opener?.getAttribute('aria-expanded')==='true'||menu?.getAttribute('aria-hidden')==='false'||menu?.classList.contains('drawer--open')||menu?.classList.contains('is-open');
    d.documentElement.classList.toggle('vf-menu-open',!!open);
  };

  const syncCart=()=>{
    const cart=d.querySelector('[data-cart-drawer]');
    const open=!!cart&&(cart.classList.contains('drawer--open')||cart.classList.contains('is-open')||cart.getAttribute('aria-hidden')==='false'||cart.classList.contains('drawer--visible'));
    d.documentElement.classList.toggle('vf-cart-open',open);
  };

  const warmMega=(item)=>{
    if(!item||item.dataset.vfMegaWarm==='1')return;
    const drop=item.querySelector('.header__dropdown');if(!drop)return;
    item.dataset.vfMegaWarm='1';
    drop.querySelectorAll('img').forEach(img=>{
      try{img.decoding='async';img.fetchPriority='low'}catch(_){}
      const done=()=>{img.classList.remove('is-loading');img.closest('.lazy-image')?.classList.remove('is-loading')};
      if(img.complete&&img.naturalWidth)done();else img.addEventListener('load',done,{once:true});
    });
  };

  /* Warm only destinations the visitor clearly intends to open. Never competes with initial LCP. */
  const warmed=new Set();
  let warmTimer=0,warmAnchor=null;
  const canWarm=()=>{
    const c=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
    return !(c&&(c.saveData||/^(slow-2g|2g)$/i.test(c.effectiveType||'')));
  };
  const eligibleAnchor=(node)=>{
    const a=node?.closest?.('a[href]');if(!a)return null;
    let u;try{u=new URL(a.href,location.href)}catch(_){return null}
    if(u.origin!==location.origin||u.href===location.href)return null;
    if(!(/^\/collections\//.test(u.pathname)||/^\/products\//.test(u.pathname)))return null;
    return {a,u};
  };
  const warmUrl=(url)=>{
    if(!canWarm()||warmed.size>=3||warmed.has(url.href))return;
    warmed.add(url.href);
    const l=d.createElement('link');l.rel='prefetch';l.as='document';l.href=url.href;
    try{l.fetchPriority='low'}catch(_){}
    d.head.appendChild(l);
  };
  const scheduleWarm=(node)=>{
    const hit=eligibleAnchor(node);if(!hit)return;
    clearTimeout(warmTimer);warmAnchor=hit.a;
    warmTimer=w.setTimeout(()=>{warmUrl(hit.u);warmAnchor=null},90);
  };
  const cancelWarm=(node)=>{
    const a=node?.closest?.('a[href]');if(a&&a===warmAnchor){clearTimeout(warmTimer);warmAnchor=null}
  };

  const boot=()=>{
    decorate();decorateMenu();copyBagIcon();stopProductAutoplay();syncMenu();syncCart();syncScroll();
    const opener=d.querySelector('.header__mobile__hamburger[data-drawer-toggle="hamburger"]');
    if(opener&&w.MutationObserver&&!opener.__vfObs){new MutationObserver(syncMenu).observe(opener,{attributes:true,attributeFilter:['aria-expanded']});opener.__vfObs=true}
    const cart=d.querySelector('[data-cart-drawer]');
    if(cart&&w.MutationObserver&&!cart.__vfObs){new MutationObserver(syncCart).observe(cart,{attributes:true,attributeFilter:['class','aria-hidden']});cart.__vfObs=true}
  };

  d.addEventListener('pointerover',e=>{const item=e.target.closest?.('.header__menu .menu__item[aria-haspopup="true"]');if(item)warmMega(item);if(e.pointerType!=='touch')scheduleWarm(e.target)},{passive:true});
  d.addEventListener('pointerout',e=>{if(e.pointerType!=='touch')cancelWarm(e.target)},{passive:true});
  d.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')scheduleWarm(e.target)},{passive:true});
  d.addEventListener('focusin',e=>{const item=e.target.closest?.('.header__menu .menu__item[aria-haspopup="true"]');if(item)warmMega(item);scheduleWarm(e.target)});
  d.addEventListener('click',e=>{
    if(e.target.closest?.('[data-drawer-toggle="hamburger"],#header-menu .drawer__underlay'))setTimeout(syncMenu,0);
    if(e.target.closest?.('[data-cart-drawer-close],[data-cart-drawer-toggle],[data-cart-toggle],.navlink--cart'))setTimeout(syncCart,40);
    const btn=e.target.closest?.('.product-item .quick-add__button,[data-vf-add],.cart-bar__submit .product__submit__add');
    if(btn&&!btn.disabled){btn.classList.add('vf-added');setTimeout(()=>btn.classList.remove('vf-added'),1100)}
  },{passive:true});
  d.addEventListener('keyup',e=>{if(e.key==='Escape'){setTimeout(syncMenu,0);setTimeout(syncCart,0)}});
  d.addEventListener('shopify:section:load',e=>{decorate(e.target||d);setTimeout(boot,20)});

  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  w.addEventListener('load',stopProductAutoplay,{once:true,passive:true});
})();

/* Quicklinks stay manual; only explicit user-intent destination warming is enabled. */
window.__VCARE_QUICKLINK_DRIFT__=true;
